import { render, staticRenderFns, recyclableRender, components } from "./uni-status-bar.vue?vue&type=template&id=86f9f2b8&scoped=true&"
var renderjs
import script from "./uni-status-bar.vue?vue&type=script&lang=js&"
export * from "./uni-status-bar.vue?vue&type=script&lang=js&"
import style0 from "./uni-status-bar.vue?vue&type=style&index=0&id=86f9f2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f9f2b8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-status-bar/uni-status-bar.vue"
export default component.exports